export const isLoadingConversations = state => {
  return state.messaging.loading_conversations;
};

export const getCircleConversations = state => {
  return state.messaging.conversations.filter(conversation => {
    return conversation.is_circle;
  });
};
export const getSimpleConversations = state => {
  return state.messaging.conversations.filter(conversation => {
    return !conversation.is_circle;
  });
};

export const getConversation = (state, conversation_guid) => {
  const filtered_conversations = state.messaging.conversations.filter(conversation => {
    return conversation.c_guid === conversation_guid;
  });
  if (filtered_conversations.length) {
    return filtered_conversations[0];
  } else {
    return {};
  }
};

export const isLoadingMessages = (state, conversation_guid) => {
  return state.messaging.loading_messages[conversation_guid];
};

export const getMessages = (state, conversation_guid) => {
  return state.messaging.messages[conversation_guid] ? state.messaging.messages[conversation_guid] : [];
};
export const hasUnreadConversations = state => {
  return state.messaging.conversations.filter(conversation => conversation["unread"]).length > 0;
};

export const unreadConversations = state => {
  return state.messaging.conversations.filter(conversation => conversation["unread"]);
};